<template>
  <StdPageContainer type="create">
    <template slot="title">
      <StdPageTitle title="签到">
        <div slot="content">
          直播状态，设置时间后，签到按照设置时间推送至观看端。回放状态不支持签到
        </div>
      </StdPageTitle>
    </template>
    <template slot="content">
      <vh-form
        class="sign-form-wrap"
        :rules="rules"
        :model="form"
        ref="form"
        inline
        label-width="96px"
      >
        <vh-form-item label="开始签到时间" v-if="form.pushType == 1" prop="pushTime">
          <vh-date-picker
            :append-to-body="false"
            class="inline_input"
            v-model="form.pushTime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :pickerOptions="pickerOptions"
            size="small"
            type="datetime"
            placeholder="选择日期时间"
            round
          ></vh-date-picker>
          自动推送签到至观看端
          <p v-if="form.pushType == 1" class="time_tips">注意：定时签到时间需大于实际开播时间</p>
        </vh-form-item>
        <vh-form-item label="签到提示">
          <vh-autocomplete
            popper-class="sign-tips-autocomplete"
            class="form-input"
            :maxlength="15"
            show-word-limit
            ref="custom_title"
            :fetch-suggestions="querySearch('custom_title')"
            v-model="form.signTip"
          >
            <template slot-scope="{ item }">
              <div v-if="item.id == -2" @click.stop="editCustom('1')" class="name" :key="item.id">
                {{ querySearchRes.custom_title.length > 11 ? '' : item.content }}
              </div>
              <div v-else-if="item.id >= 0" class="name" :key="item.id">
                {{ item.content }}
                <div class="tips-ctr">
                  <vh-button type="text" @click.stop="editCustom('1', item)">编辑</vh-button>
                  <vh-button type="text" @click.stop="delCustomTips(item.id)">删除</vh-button>
                </div>
              </div>
              <div v-else class="name" :key="item.id">{{ item.content }}</div>
            </template>
          </vh-autocomplete>
        </vh-form-item>
        <vh-form-item label="结束时长">
          <vh-select class="form-input" v-model="form.duration" popper-class="sign-select">
            <vh-option
              v-for="(opt, idx) in durationOps"
              :key="idx"
              :label="opt.label"
              :value="opt.value"
              class="sign-form-wrap-select"
            ></vh-option>
          </vh-select>
        </vh-form-item>
        <vh-form-item label=" " v-show="form.duration == -1" prop="custom">
          <vh-input
            class="form-input"
            placeholder="输入范围10-9999"
            style="width: auto"
            v-model="form.custom"
            :maxlength="4"
          ></vh-input>
          秒
        </vh-form-item>
        <vh-form-item label="签到成功提示">
          <vh-autocomplete
            class="form-input"
            popper-class="sign-tips-autocomplete"
            :maxlength="15"
            show-word-limit
            ref="custom_success_tips"
            :fetch-suggestions="querySearch('custom_success_tips')"
            v-model="form.signInsuccessTips"
          >
            <template slot-scope="{ item }">
              <div v-if="item.id == -2" @click.stop="editCustom('2')" class="name" :key="item.id">
                {{ querySearchRes.custom_success_tips.length > 11 ? '' : item.content }}
              </div>
              <div v-else-if="item.id >= 0" class="name" :key="item.id">
                {{ item.content }}
                <div class="tips-ctr">
                  <vh-button type="text" @click.stop="editCustom('2', item)">编辑</vh-button>
                  <vh-button type="text" @click.stop="delCustomTips(item.id)">删除</vh-button>
                </div>
              </div>
              <div v-else class="name" :key="item.id">{{ item.content }}</div>
            </template>
          </vh-autocomplete>
        </vh-form-item>

        <vh-form-item label="提示音效">
          <vh-switch
            v-model="form.sound_status"
            active-color="#FB3A32"
            :active-value="1"
            :inactive-value="0"
            :active-text="
              (!!form.sound_status ? '已开启' : '开启后') + '，观众收到签到时可听到提示音'
            "
          ></vh-switch>
          <div class="trial-sound">
            <vh-button type="text" @click="handleTrialSound">试听</vh-button>
            <vh-tooltip placement="right">
              <div class="sign-form-wrap-tip" slot="content" style="background: #333">
                <div>
                  观众进入直播间时需要有操作交互（如点击、触摸、按键），否则收到签到面板可能会听不到声音，原因如下：
                </div>
                <div>
                  目前大部分览器对网页媒体自动播放（尤其带声音的）有明确严格限制，旨在提升用户体验和减少干扰。如果用户没有与页面发生交互（如点击、触摸、按键），可能无法自动播放提示音。
                </div>
              </div>
              <i class="vh-iconfont vh-line-question" style="margin-left: 4px"></i>
            </vh-tooltip>
            <TrialSound ref="audioTrialSound" />
          </div>
        </vh-form-item>

        <vh-form-item label="踢出直播间">
          <vh-switch
            class="kick-switch"
            v-model="form.auto_kick_unsigned"
            active-color="#FB3A32"
            :active-value="1"
            :inactive-value="0"
            :active-text="
              (!!form.auto_kick_unsigned ? '已开启' : '开启后') +
              '，未签到用户将被踢出直播间；慎用，若观众恰好在签到快结束时进入直播间，存在还来不及点签到就被动离开的情况'
            "
          ></vh-switch>
        </vh-form-item>
        <vh-form-item label="自动签到">
          <vh-switch
            @change="autoSignChange"
            v-model="form.autoSign"
            active-color="#FB3A32"
            :active-text="
              (!!form.autoSign ? '已开启' : '开启后') +
              '，只要直播不结束或者不手动结束签到，观众将会收到多次签到提示'
            "
          ></vh-switch>
          <!-- <vh-tooltip placement="right">
        <div class="sign-form-wrap-tip" slot="content" style="background: #333">
          <div>1.默认关闭；</div>
          <div>2.开启自动签到后，观众将在设置的时间收到签到提示；</div>
          <div>3.活动结束或回放时，观看者收不到签到提示。</div>
        </div>
        <i class="vh-iconfont vh-line-question" style="vertical-align: middle"></i>
      </vh-tooltip> -->
        </vh-form-item>
        <vh-form-item label="间隔时长" v-show="form.autoSign" class="formm-item--interval">
          <vh-select class="form-input" v-model="form.intervalValue" popper-class="sign-select">
            <vh-option
              v-for="(opt, idx) in intervalOps"
              :key="idx"
              :label="opt.label"
              :value="opt.value"
              class="select-option"
            ></vh-option>
          </vh-select>
          <vh-tooltip placement="right" class="form-input-tip">
            <div class="sign-form-wrap-tip" slot="content" style="background: #333">
              <div>
                签到间隔时长：开启自动签到后，设置好每次签到的间隔时间，观众将在指定时间收到签到提示
              </div>
            </div>
            <i class="vh-iconfont vh-line-question" style="padding-left: 6px"></i>
          </vh-tooltip>
        </vh-form-item>
        <vh-form-item
          label=" "
          v-if="form.intervalValue == -1 && form.autoSign"
          prop="intervalCustom"
          class="formm-item--interval"
        >
          <vh-input
            class="form-input"
            v-model="form.intervalCustom"
            placeholder="输入范围5-120"
            style="width: auto; width: 200px"
          >
            <template slot="append">分钟</template>
          </vh-input>
        </vh-form-item>
        <div class="sign-form-wrap-start">
          <vh-button type="primary" size="" round class="sign-form-wrap-start-btn" @click="submit">
            保存
          </vh-button>
        </div>
        <vh-dialog
          :visible.sync="showEditTips"
          width="400px"
          class="sign_tips"
          append-to-body
          title="设置"
          top="25vh"
        >
          <div>
            <vh-input
              :rows="4"
              ref="tipsInput"
              placeholder="请输入内容"
              v-model="curEditTips.content"
              maxlength="15"
              show-word-limit
            ></vh-input>
          </div>
          <span slot="footer">
            <vh-button
              type="primary"
              @click="saveCustomTips"
              :disabled="!curEditTips.content"
              size="medium"
              round
            >
              确 定
            </vh-button>
            <vh-button type="default" @click="showEditTips = false" size="medium" round>
              取 消
            </vh-button>
          </span>
        </vh-dialog>
        <div class="cancel-signin-dialog" v-if="!!curSignIn">
          <vh-dialog
            :visible="!!curSignIn"
            width="400px"
            class=""
            title="签到"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            top="25vh"
          >
            <div class="cancel-signin-content">
              {{ `您已设置定时推送签到，将在${curSignIn?.push_time}，自动推送签到至观看端` }}
            </div>
            <span slot="footer">
              <vh-button type="primary" @click="handleCancelSignIn" size="medium" round>
                取消签到
              </vh-button>
            </span>
          </vh-dialog>
        </div>
      </vh-form>
      <router-link
        :to="{
          path: '/live/interactionDetail',
          query: {
            roomId: this.$route.query.roomId,
            id: this.$route.params.str,
            title: '签到',
            wType: this.$route.query.type
          }
        }"
        class="link data_link"
      >
        查看签到人数
      </router-link>
    </template>
  </StdPageContainer>
</template>

<script>
  import regRule from '@/utils/reg-rule.js';
  import { throttle } from 'lodash';
  import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
  import TrialSound from './components/trial-sound/index.vue';
  export default {
    name: 'SigninSet',
    components: { TrialSound, StdPageContainer },
    data() {
      const tipText = '主持人发起了签到';
      const resTipText = '签到成功';
      return {
        defaultText: tipText,
        defaultResTipText: resTipText,
        form: {
          pushType: 1, // 签到推送方式，0：手动，1：定时
          signTip: tipText, // 签到提示语
          duration: 30, // 签到显示的时间，单位秒，
          signInsuccessTips: resTipText, // 签到成功提示语,
          autoSign: false, // 是否自动发起签到，1自动，0取消自动
          intervalValue: 5, // 自动发起签到的轮询定时时间，单位秒
          intervalCustom: 5,
          custom: 90,
          sound_status: 0, // 提示音效开关
          auto_kick_unsigned: 0, //未签到踢出直播间，1开启，0关闭
          pushTime: '' //定时推送时间
        },
        durationOps: [
          {
            value: 10,
            label: '10秒'
          },
          {
            value: 30,
            label: '30秒'
          },
          {
            value: 60,
            label: '60秒'
          },
          {
            value: 120,
            label: '2分钟'
          },
          {
            value: 180,
            label: '3分钟'
          },
          {
            value: -1,
            label: '自定义'
          }
        ],
        intervalOps: [
          // {
          //   value: 60,
          //   label: '1分钟'
          // },
          {
            value: 5,
            label: '5分钟'
          },
          {
            value: 15,
            label: '15分钟'
          },
          {
            value: 30,
            label: '30分钟'
          },
          {
            value: -1,
            label: '自定义'
          }
        ],
        showEditTips: false, //提示语编辑弹框
        curSignIn: null, //取消签到弹框
        curEditTips: {
          id: undefined,
          content: ''
        },
        querySearchRes: {},
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      };
    },
    computed: {
      isLiving() {
        return true;
      }
    },
    created() {
      this.rules = {
        pushTime: {
          validator: (rule, value, callback) => {
            if (this.form.pushType == 1 && !value) {
              callback(new Error('请选择开始签到时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        },
        custom: {
          validator: (rule, value, callback) => {
            console.log(
              this.form.duration == -1 &&
                regRule.positiveInt0.test(value) &&
                value >= 10 &&
                value <= 9999
            );
            if (
              !(
                this.form.duration != -1 ||
                (this.form.duration == -1 &&
                  regRule.positiveInt0.test(value) &&
                  value >= 10 &&
                  value <= 9999)
              )
            ) {
              callback(new Error('请输入10-9999正整数'));
            } else if (
              this.form.autoSign &&
              ((this.form.duration != -1 && this.form.duration >= this.form.interval) ||
                (this.form.duration == -1 && this.form.custom >= this.form.interval))
            ) {
              callback(new Error('结束时长需小于间隔时长'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        },
        intervalCustom: {
          validator: (rule, value, callback) => {
            // 使用正则验证5-120的整数
            const regex = /^(5|6|7|8|9|10|[1-9]\d|1[0-1]\d|120)$/;
            if (!regex.test(value)) {
              return callback(new Error('请输入5-120之间的整数'));
            }
            callback();
          },
          trigger: 'blur'
        }
      };
    },
    mounted() {
      this.getSignInfo();
    },
    methods: {
      getSignInfo() {
        this.$fetch('getSignDetail', { room_id: this.$route.query.roomId }).then(res => {
          if (res.data.push_type == 1 && res.data.push_status == 0) {
            this.curSignIn = res.data;
          }
        });
      },

      querySearch(type) {
        return (queryString, cb) => {
          cb('');
          this.$fetch('getSignCustomTips').then(res => {
            if (res.code == 200) {
              res.data.custom_title.unshift({
                id: -1,
                content: this.defaultText
              });

              res.data.custom_title.push({
                id: -2,
                content: '自定义文案'
              });
              res.data.custom_success_tips.unshift({
                id: -1,
                content: this.defaultResTipText
              });

              res.data.custom_success_tips.push({
                id: -2,
                content: '自定义文案'
              });
              this.querySearchRes = res.data;
              cb(
                res.data[type].map(item => {
                  item.value = item.content;
                  return item;
                })
              );
            }
          });
        };
      },
      autoSignChange(value) {
        console.warn('test----自动签到  改变值', value);
        // window.sessionStorage.setItem('isAutoSign', value)
      },
      // tipFocus(e) {
      //   if (e.target.value === this.defaultText) {
      //     this.form.signTip = '';
      //   }
      // },
      // tipBlur(e) {
      //   if (e.target.value === '') {
      //     this.form.signTip = this.defaultText;
      //   }
      // },
      submit: throttle(
        function () {
          this.$refs.form.validate(valid => {
            if (valid) {
              const data = Object.assign({}, this.form, {
                duration: this.form.duration != -1 ? this.form.duration : Number(this.form.custom),
                interval:
                  (this.form.intervalValue != -1
                    ? this.form.intervalValue
                    : Number(this.form.intervalCustom)) * 60
              });
              this.$fetch('startSignIn', {
                room_id: this.$route.query.roomId,
                sign_tips: data.signTip, // 签到提示语
                show_time: data.duration, // 签到显示的时间，单位秒，默认30
                is_auto_sign: Number(data.autoSign), // 是否自动发起签到，1自动，0取消自动，默认0
                auto_sign_time: data.interval, // 自动发起签到的轮询定时时间，单位秒
                auto_kick_unsigned: data.auto_kick_unsigned, // 是否自动踢出未签到用户，1是，0否，默认0
                sign_in_success_tips: data.signInsuccessTips,
                push_type: data.pushType,
                push_time: data.pushTime,
                sound_status: data.sound_status
              })
                .then(res => {
                  if (res.code == 200) {
                    this.curSignIn = res.data;
                  }
                })
                .catch(err => {
                  this.$vhMessage.error(err.msg);
                });
            }
          });
        },
        2000,
        { trailing: false }
      ),

      editCustom(type, item) {
        this.curEditTips = {
          id: item?.id,
          content: item?.content,
          type
        };
        this.showEditTips = true;
        this.$nextTick(() => {
          this.$refs.custom_success_tips.activated = false;
          this.$refs.custom_title.activated = false;
        });
      },
      async saveCustomTips() {
        if (
          (this.curEditTips.type == 1 && this.curEditTips.content == '主持人发起了签到') ||
          (this.curEditTips.type == 1 && this.curEditTips.content == '签到成功')
        ) {
          this.$vhMessage.error('当前内容已存在');
          return;
        }

        const res = await (!this.curEditTips.id
          ? this.$fetch('createSignCustomTips', this.curEditTips)
          : this.$fetch('editSignCustomTips', this.curEditTips)
        ).finally(data => data);
        if (res.code == 200) {
          this.showEditTips = false;
          this.curEditTips.type == 1
            ? (this.form.signTip = this.curEditTips.content)
            : (this.form.signInsuccessTips = this.curEditTips.content);
          this.$vhMessage.success('保存成功');
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      async delCustomTips(id) {
        const res = await this.$fetch('delSignCustomTips', { id }).finally(data => data);
        if (res.code == 200) {
          this.$vhMessage.success('删除成功');
          this.$refs.custom_title.$data.suggestions =
            this.$refs.custom_title.$data.suggestions.filter(el => el.id !== id);
          this.$refs.custom_success_tips.$data.suggestions =
            this.$refs.custom_success_tips.$data.suggestions.filter(el => el.id !== id);
          this.querySearchRes.custom_title = this.querySearchRes.custom_title.filter(
            el => el.id !== id
          );
          this.querySearchRes.custom_success_tips = this.querySearchRes.custom_success_tips.filter(
            el => el.id !== id
          );
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      // 试听
      handleTrialSound() {
        this.$refs['audioTrialSound']?.play();
      },
      handleCancelSignIn() {
        this.$vhConfirm('取消后观众将无法进行签到，确定取消设置？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton: true
        })
          .then(() => {
            this.$fetch('delSignIn', {
              room_id: this.$route.query.roomId,
              sign_ids: this.curSignIn.id
            }).then(res => {
              if (res.code == 200) {
                this.$vhMessage.success('定时签到取消成功');
                this.curSignIn = null;
              }
            });
          })
          .catch(() => {
            const data = this.curSignIn;
            this.curSignIn = null;
            this.$nextTick(() => {
              this.curSignIn = data;
            });
          });
      }
    }
  };
</script>
<style lang="less" scoped>
  .tips-ctr {
    float: right;
  }
  .inline_input {
    width: 176px;
    vertical-align: middle;
  }
  .tips {
    line-height: 20px;
    font-size: 12px;
    color: #262626;
  }
  .time_tips {
    // padding-left: 96px;
    font-size: 12px;
    line-height: 20px;
    // margin-top: -10px;
    font-size: #262626;
  }
  .cancel-signin-dialog {
    /deep/ .vh-dialog__wrapper {
      position: absolute;
    }
    /deep/ .v-modal {
      position: absolute;
    }
  }
  .data_link {
    position: absolute;
    right: 30px;
    top: 50px;
  }
</style>
<style lang="less">
  .sign-form-wrap {
    width: 660px;
    padding-bottom: 32px;
    .vh-form-item {
      margin-right: 0;
      width: 100%;
      .vh-form-item__content {
        width: calc(100% - 96px);
        .form-input {
          width: 100%;
          &-tip {
            position: absolute;
            left: 100%;
          }
        }
      }
    }
    .vh-form-item.formm-item--interval {
      .vh-form-item__content {
        width: calc(100% - 96px);
      }
    }
    .vh-switch {
      margin-right: 5px;
      height: 16px;
      line-height: 16px;
      &__core {
        width: 28px !important;
        height: 16px;
        flex-shrink: 0;
      }
      &__core:after {
        width: 12px;
        height: 12px;
      }
      .vh-switch__label--right * {
        line-height: 20px;
      }

      &.kick-switch {
        .vh-switch__label span {
          color: #fb2626;
        }
      }
    }

    .trial-sound {
      display: inline-block;
      vertical-align: middle;
    }

    .vh-switch.is-checked .vh-switch__core::after {
      margin-left: -13px;
    }
    &-select {
      line-height: 40px !important;
      &:hover {
        background-color: #f7f7f7;
      }
      &.hover {
        font-weight: normal;
        background: none;
      }
      &:hover {
        background-color: #f7f7f7;
      }
      &.selected {
        background-color: #f7f7f7;
        font-weight: normal;
        color: #606266;
      }
    }
    &-tip {
      line-height: 18px;
      font-size: 12px;
      width: 238px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
    &-start {
      text-align: center;
      &-btn {
        width: 120px;
      }
    }
    .vh-iconfont {
      color: #999;
      font-size: 14px;
    }
    .vh-form-item.is-success {
      .vh-input__inner {
        border-color: #e2e2e2;
      }
    }
  }
  .sign-tips-autocomplete {
    li {
      padding: 0;
      & > div {
        padding: 0 10px;
      }
    }
  }
</style>
